import _classCallCheck from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { UpploadEffect } from "../effect";
import { safeListen, fitImageToContainer, canvasToBlob } from "../helpers/elements";

var UpploadFilterBaseClass =
/*#__PURE__*/
function (_UpploadEffect) {
  _inherits(UpploadFilterBaseClass, _UpploadEffect);

  function UpploadFilterBaseClass() {
    var _this;

    _classCallCheck(this, UpploadFilterBaseClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UpploadFilterBaseClass).apply(this, arguments));
    _this.canvas = document.createElement("canvas");
    _this.originalfileURL = "";
    _this.cssFilter = "";
    _this.max = 10;
    _this.unit = "px";
    _this.value = 0;

    _this.supports = function () {
      var _a;

      return !!(_this.canvas.getContext && _this.canvas.getContext("2d") && typeof ((_a = _this.canvas.getContext("2d")) === null || _a === void 0 ? void 0 : _a.filter) === "string");
    };

    _this.template = function (_ref) {
      var file = _ref.file,
          translate = _ref.translate;
      var image = URL.createObjectURL(file);
      _this.originalfileURL = image;
      return "\n      <div class=\"uppload-hue-image\">\n        <img style=\"width: 20px\" alt=\"\" src=\"".concat(image, "\">\n      </div>\n      <div class=\"settings\">\n        <input type=\"range\" value=\"").concat(_this.value, "\" min=\"0\" max=\"").concat(_this.max, "\">\n        <span class=\"value\"><span>0</span>").concat(translate("units.".concat(_this.unit)) || _this.unit, "</span>\n      </div>\n    ");
    };

    _this.handlers = function (params) {
      var hueElement = params.uppload.container.querySelector(".uppload-hue-image img");

      if (hueElement) {
        fitImageToContainer(params, hueElement).then(function () {
          var range = params.uppload.container.querySelector(".settings input[type='range']");
          if (range) safeListen(range, "change", _this.update.bind(_assertThisInitialized(_this), params));
        });
      }
    };

    return _this;
  }

  _createClass(UpploadFilterBaseClass, [{
    key: "imageToCanvasBlob",
    value: function imageToCanvasBlob(filters) {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.canvas = document.createElement("canvas");
        var image = document.createElement("img");
        image.src = _this2.originalfileURL;

        image.onload = function () {
          _this2.canvas.width = image.width;
          _this2.canvas.height = image.height;

          var context = _this2.canvas.getContext("2d");

          if (!context) return;
          context.clearRect(0, 0, _this2.canvas.width, _this2.canvas.height);
          context.filter = filters;
          context.drawImage(image, 0, 0);
          canvasToBlob(_this2.canvas).then(function (blob) {
            return resolve(blob);
          });
        };
      });
    }
  }, {
    key: "update",
    value: function update(params) {
      var value = 0;
      var range = params.uppload.container.querySelector(".settings input[type='range']");
      if (range) value = parseInt(range.value);
      var displayer = params.uppload.container.querySelector(".settings .value span");
      if (displayer) displayer.innerHTML = value.toString();
      var hueElement = params.uppload.container.querySelector(".uppload-hue-image img");
      if (!hueElement) return;
      this.imageToCanvasBlob("".concat(this.cssFilter, "(").concat(range.value).concat(this.unit, ")")).then(function (blob) {
        if (!blob) return;
        params.next(blob);
        var image = URL.createObjectURL(blob);
        hueElement.setAttribute("src", image);
      });
    }
  }]);

  return UpploadFilterBaseClass;
}(UpploadEffect);

export { UpploadFilterBaseClass as default };